/////////////// INIT DROPDOWN ///////////////

// Burger menu toogle
function menuOpen(menu, btn) {
  menu.classList.toggle('open');
  btn.classList.toggle('open');

  if (menu.classList.contains('open')) {
    btn.setAttribute('aria-expanded', 'true');
    btn.setAttribute('aria-label', btn.getAttribute('data-label-close'));
  } else {
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', btn.getAttribute('data-label-open'));
  }
}
document.querySelector('.sidebar__btn').addEventListener('click', function () {
  let menu = document.querySelector('.sidebar__submenu');
  let btn = document.querySelector('.sidebar__btn');
  menuOpen(menu, btn);
});

let sidebarToggles = document.querySelectorAll(
  '.page_item_has_children > a > .toggle'
);

if (sidebarToggles) {
  sidebarToggles.forEach((sidebarToggle) => {
    sidebarToggle.addEventListener('click', function (e) {
      e.preventDefault();
      sidebarToggle.closest('.page_item_has_children').classList.toggle('open');
    });

    if (
      sidebarToggle
        .closest('.page_item_has_children')
        .classList.contains('current_page_ancestor')
    ) {
      sidebarToggle.closest('.page_item_has_children').classList.add('open');
    }
  });
}
